import { observer } from 'mobx-react';
import FormCommon from '@/components/FormCommon';
import { useBackground, useBgImg } from '@/store';
import { CheckboxItem } from '@/components/FormItem';
import { $fm } from '@/Intl';

import BgSet from './BgSet';

export default observer(() => {
  const [background, updateBackground, defaults] = useBackground();
  const [, setBgImg] = useBgImg();
  return (
    <FormCommon
      initialValues={background}
      onUpdate={updateBackground}
      defaults={defaults}
      onReset={() => {
        setBgImg(null);
      }}
    >
      <BgSet />
      <CheckboxItem
        label={$fm('DISABLE_CHANGE_WALLPAPER')}
        name='disableChangeWallpaper'
      />
    </FormCommon>
  );
});
